import React, { useState } from "react";
import cx from "clsx";
import { Transition } from "react-transition-group";
import { isTablet } from "react-device-detect";

import { MENU_ITEMS } from "./constants";

import globalStyles from "@/styles/global.module.scss";
import navStyles from "./navbar.module.scss";

const DesktopNavbar = props => {
  const [itemHovered, setItemHovered] = useState(null);
  const handleButtonHover = itemHovered => () => setItemHovered(itemHovered);
  const { onNavLinkClick, location, isOpen, onOpen, onClose, onToggle } = props;

  const handlers = isTablet
    ? {
        onClick: onToggle
      }
    : {
        onMouseEnter: onOpen,
        onMouseLeave: onClose,
        onFocus: onOpen,
        onBlur: onClose
      };

  return (
    <div className={navStyles.container}>
      <Transition enter exit in={isOpen} timeout={25}>
        {state => {
          return (
            <div
              className={cx(
                navStyles.buttons,
                navStyles.desktopOpenAnimation,
                navStyles[state]
              )}
              {...handlers}
            >
              {MENU_ITEMS.map((item, index) => {
                const { icon: Icon } = item;

                const btnHandlers = isTablet
                  ? {
                      onClick: isOpen ? onNavLinkClick(item) : onOpen
                    }
                  : {
                      onClick: isOpen ? onNavLinkClick(item) : onOpen,
                      onMouseEnter: handleButtonHover(index),
                      onMouseLeave: handleButtonHover(null),
                      onFocus: handleButtonHover(index),
                      onBlur: handleButtonHover(null)
                    };

                return (
                  <button
                    key={`nav-${item.label}`}
                    className={cx(
                      globalStyles.buttonReset,
                      navStyles.button,
                      isTablet && navStyles.isTablet
                    )}
                    {...btnHandlers}
                  >
                    <div
                      className={cx(
                        navStyles.buttonInner,
                        !isTablet && navStyles.hoverActive,
                        itemHovered === index && navStyles.hovered,
                        location &&
                          item.link === location.pathname &&
                          navStyles.active
                      )}
                      style={item.containerStyle}
                    >
                      <div
                        className={cx(
                          navStyles.labelContainer,
                          navStyles.labelAnimation,
                          navStyles[state]
                        )}
                      >
                        {item.label}
                      </div>
                      <div className={navStyles.iconContainer}>
                        {Icon ? (
                          <Icon
                            className={navStyles.buttonIcon}
                            style={item.iconStyle}
                            alt={item.label}
                          />
                        ) : null}
                      </div>
                    </div>
                  </button>
                );
              })}
            </div>
          );
        }}
      </Transition>
    </div>
  );
};

export default DesktopNavbar;
